import { atom, selector, selectorFamily } from 'recoil';
import { Notification, NotificationCore, NotificationTypeItem } from '../types/notification';
import { NotificationOrigin } from '../types/notificationConfig';

export const notificationsState = atom<NotificationCore[] | undefined>({
  key: 'app.client.notifications',
  default: undefined,
});

export const internalNotificationTypeState = atom<string>({
  key: 'app.client.notification.internalId',
  default: '',
});

export const selectedNotificationTypeState = selectorFamily<NotificationTypeItem, string>({
  key: 'app.client.notification.type',
  get:
    (internalNotificationTypeState) =>
    ({ get }) => {
      const notificationTypes = get(notificationTypesState);
      const selectedNotification = notificationTypes?.find(
        (notificationType) => notificationType.internalId === internalNotificationTypeState,
      );
      return selectedNotification ?? { notificationId: -1, name: 'Todos', origin: NotificationOrigin.alarms };
    },
});

export const unreadNotificationsCountState = atom<number | undefined>({
  key: 'app.client.notifications.unread.count',
  default: undefined,
});

export const notificationsCursorPageState = atom<
  | {
      before: string;
      after: string;
      hasNext: boolean;
    }
  | undefined
>({
  key: 'app.client.notifications.page.cursor',
  default: undefined,
});

export const notificationIdsState = selector<string[] | undefined>({
  key: 'app.client.notificationIds',
  get: ({ get }) => {
    const notifications = get(notificationsState);
    if (!notifications) return;
    return notifications.map((notification) => notification._id);
  },
});

export const notificationState = selectorFamily<NotificationCore | undefined, string>({
  key: 'app.client.notification',
  get:
    (id) =>
    ({ get }) => {
      const notifications = get(notificationsState);
      if (!notifications) return;
      return notifications.find((notification) => notification._id === id);
    },
  set:
    (id) =>
    ({ set, get }) => {
      const notifications = get(notificationsState);
      if (!notifications) return;
      const newNotifications = notifications.map((notification) => {
        if (notification._id === id) {
          return { ...notification, read: true };
        }
        return notification;
      });
      set(notificationsState, newNotifications);
    },
});

//notification detail
export const notificationSelectedState = atom<Notification | undefined>({
  key: 'app.client.notificationSettings.update',
  default: undefined,
});

export const notificationTypesState = atom<(NotificationTypeItem & { internalId: string })[] | undefined>({
  key: 'app.client.notifications.types',
  default: undefined,
});
